import axios from 'axios';

// const OUTSIDE_CLICK_AUDIO = [
//     "new-free/s_k_1.wav",
//     "new-free/s_k_2.wav",
//     "new-free/s_k_3.wav",
//     "new-free/s_k_4.wav",
//     "new-free/s_k_5.wav",
//     "new-free/s_k_6.wav",
//     // TODO: 初期アニメーション以外の音声を追加
// ]

const state = () => {
    return {
        data: {},
    };
};

const getters = {
    getSound: (state) => {
        return (key) => {
            return state.data[key];
        };
    },
    // iosAutoLoadSounds: (state) => {
    //     return Object.fromEntries(Object.entries(state.data).filter(([_, value]) => value.iosAutoLoad));
    // },
};

const mutations = {
    setSounds(state, sounds) {
        state.data = sounds;
    },
    setLoaded(state, loaded) {
        state.loaded = loaded;
    },
};

const actions = {
    async loadSounds({ commit }) {
        const response = await axios.get('data/sounds.json');
        // const sounds = response.data;
        // const s = Object.entries(sounds).reduce((acc, [key, value]) => {
        //     acc[key] = {
        //         data: value,
        //         iosAutoLoad: OUTSIDE_CLICK_AUDIO.includes(key),
        //     };
        //     return acc;
        // }, {});

        commit('setSounds', response.data);
        commit('setLoaded', true);
        // console.log('Sounds loaded');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};